import { render, staticRenderFns } from "./TariffComparisonSelect.vue?vue&type=template&id=94857fba&scoped=true&"
import script from "./TariffComparisonSelect.vue?vue&type=script&lang=ts&"
export * from "./TariffComparisonSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TariffComparisonSelect.vue?vue&type=style&index=0&id=94857fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94857fba",
  null
  
)

export default component.exports